module.exports = __webpack_public_path__ + "03_short_gray.432c4bd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/03_short_gray.png
// module id = 0ARk
// module chunks = 0